/**
 * Screen 相关
 */

module.exports = {
  version: {},
  blockly: [
    {
      source: {},
      code: '',
      label: '默认',
    },
  ],
  isRoot: false,
  isScreen: true,
  isTemplate: false,
  primaryFrameId: '',
  ads: {
    fb: '',
    gg: '',
    tt: '',
    re: '',
    tw: '',
  },
  seo: {
    keywords: '',
    description: '',
    image: '',
  },
  og: {
    title: '',
    description: '',
    image: '',
    twiterCard: '',
    site_name: '',
    alternateName: '',
    url: '',
  },
  webTitle: '自定义',
  normalScreen: {
    width: 0,
    height: 0,
  },
  globalCode: [
    {
      html: '',
      javascript: '',
      css: '',
      label: '默认',
    },
  ],
  timezone: {
    include: '',
    exclude: '',
  },
  code: '-',
  __rid: '',
  __prid: '',
  updated: '',
  deviceInfo: {
    type: 'normal',
  },
  locale: '__default',
  fallbackLocale: '__default',
  i18n: {
    __default: {
      custom: {},
      __variables__: {},
    },
  },
  googleFonts: {},
  remoteInfo: {},
  bodyColor: '#EFEFEF',
  adaptive: {
    width: '500',
    background: '',
  },
  media: {
    orientation: 'width',
  },
  formSchema: {},
  cypress: {
    edit: [],
  },
  ossImgRatio: 80,
  baseUnit: 'px',
  file_code: '',
};
